import { render, staticRenderFns } from "./webRight.vue?vue&type=template&id=ed916950&scoped=true&"
import script from "./webRight.vue?vue&type=script&lang=js&"
export * from "./webRight.vue?vue&type=script&lang=js&"
import style0 from "./webRight.vue?vue&type=style&index=0&id=ed916950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed916950",
  null
  
)

export default component.exports